import React from "react";
import { Link } from "react-router-dom";
import OptimizedImage from "./OptimizedImage";

const RelatedPosts = ({ posts = [], imageFallback, title = "Related posts" }) => {
  if (posts.length === 0) return null;

  return (
    <section className="mt-16 rounded-[32px] border border-slate-200 bg-white p-6 shadow-[0_20px_50px_rgba(15,23,42,0.04)] md:p-8">
      <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#FF6B00]">{title}</p>
      <div className="mt-6 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {posts.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="group overflow-hidden rounded-[28px] border border-slate-200 bg-[#FFF9F4] transition duration-300 hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(15,23,42,0.08)]">
            <div className="aspect-[16/9] overflow-hidden bg-slate-100">
              <OptimizedImage
                src={post.image || imageFallback}
                alt={post.title}
                width="1200"
                height="675"
                className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#FF6B00]">
                {post.category || "Blog"}
              </p>
              <h3 className="mt-3 text-xl font-semibold text-slate-900 font-unbounded">
                {post.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-slate-600 font-poppins">
                {post.excerpt}
              </p>
              <span className="mt-5 inline-flex text-sm font-semibold text-[#FF6B00] transition-transform group-hover:translate-x-1">
                Read article
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;